<template>
  <div class="h-screen overflow-hidden flex flex-col justify-between bg-white border-solid border-l border-0 border-gray-border">
    <div>
      <div class="border-solid border-b border-0 border-gray-border px-8 pb-8">
        <h3 class="font-semibold mt-8 truncate">
          <span class="text-gray-dark">{{ botDisplayName }}</span>
          <span class="text-gray ml-1">/</span>
          <span class="text-black ml-1">Add market</span>
        </h3>
      </div>

      <settings-bot-market-form v-if="hasAvailableMarketOptions"
                                v-model="marketForm"
                                :multi-bots="multiBots"
                                :exclude-multi-bot-id="bot.multi_bot_id"
                                :existing-only="true"
                                :allow-timezone-fallback="true"
                                content-class="px-8"
      />
      <p v-else class="mt-8 px-8 text-gray-dark">
        <template v-if="showUnreleased">
          No markets available for this bot. <router-link :to="{ name: 'markets' }">Manage markets in Settings &gt; Markets</router-link>.
        </template>
        <template v-else>
          No markets available for this bot yet.
        </template>
      </p>
    </div>

    <div class="grid grid-cols-2 gap-4 mb-6 px-8">
      <busy-button id="addMarketCreateButton"
                   variant="primary"
                   class="col-span-1"
                   :is-loading="isLoading"
                   :is-disabled="!hasAvailableMarketOptions || !isMarketFormValid || isLoading"
                   @click="submit"
      >
        Create
      </busy-button>
      <base-button variant="bordered"
                   class="col-span-1 justify-center"
                   @click="$emit('cancel')"
      >
        Cancel
      </base-button>
    </div>
  </div>
</template>

<script>
import BusyButton from '@/components/common/BusyButton'
import BaseButton from '@/components/base-components/BaseButton.vue'
import SettingsBotMarketForm from '@/components/settings/bots/SettingsBotMarketForm.vue'
import botModule from '@/store/modules/bot.module'
import {
  createDefaultMarketForm,
  getAvailableMarketOptions,
  isMarketFormValid
} from '@/utils/market.utils'

export default {
  name: 'SettingsBotAddMarketEditor',

  components: {
    BusyButton,
    BaseButton,
    SettingsBotMarketForm
  },

  props: {
    bot: {
      type: Object,
      required: true
    },
    multiBots: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  emits: ['cancel', 'create'],

  data() {
    return {
      marketForm: createDefaultMarketForm({
        language: this.bot.language,
        timezone: this.bot.timezone
      })
    }
  },

  computed: {
    botDisplayName() {
      // The group's display name is its PRIMARY bot's name. The group's root multi-bot
      // is the one whose id equals the bot's multi_bot_id (i.e. mb.id === mb.primaryBot.multi_bot_id);
      // use its primaryBot.name (e.g. "multi market bot"), not the root's own name (a market label).
      const rootMultiBot = (this.multiBots || []).find(mb => mb.id === this.bot.multi_bot_id)
      return rootMultiBot?.primaryBot?.name || this.bot.name
    },
    bots() {
      return botModule.getBotList()
    },
    hasAvailableMarketOptions() {
      return getAvailableMarketOptions(this.multiBots, this.bot.multi_bot_id).length > 0
    },
    isMarketFormValid() {
      return isMarketFormValid(this.marketForm, this.hasAvailableMarketOptions, this.bots)
    }
  },

  methods: {
    submit() {
      this.$emit('create', { ...this.marketForm })
    }
  }
}
</script>
